
import { CaseStudy } from "@/types/expertise";

export const caseStudies: CaseStudy[] = [
  {
    id: "case1",
    title: "Contract Review Automation",
    client: "Orangetheory",
    challenge: "Manual review of 1,000+ franchise agreements, consuming hundreds of attorney hours and creating workflow bottlenecks.",
    solution: "Implemented an AI-powered contract analysis platform that automatically identified, extracted, and categorized key provisions across multiple agreement types.",
    results: [
      "Reduced contract review time by 80%",
      "Achieved 94% accuracy in key term identification",
      "Saved hundreds of legal team hours",
      "Completed project in half the expected time"
    ],
    source: {
      text: "Virtasant — AI Contract Management: 80% Time Savings in Legal Work",
      url: "https://www.virtasant.com/ai-today/ai-contract-mangement-legal"
    },
    image: "/lovable-uploads/optimized/ai-generic-3-800w.webp"
  },
  {
    id: "case2",
    title: "Litigation Outcome Prediction",
    client: "Mid-Sized Law Firm",
    challenge: "Difficulty forecasting litigation outcomes consistently, relying on manual research and subjective attorney experience.",
    solution: "Deployed AI-powered litigation analytics to predict case outcomes based on historical data, judge behavior, and court documents.",
    results: [
      "Enhanced prediction accuracy for case outcomes by 85%",
      "Improved strategic decision-making, leading to more favorable settlements",
      "Reduced research time by 60%",
      "Increased client satisfaction through data-backed counsel"
    ],
    source: {
      text: "American Bar Association – Using AI for Predictive Analytics in Litigation",
      url: "https://www.americanbar.org/groups/senior_lawyers/resources/voice-of-experience/2024-october/using-ai-for-predictive-analytics-in-litigation/"
    },
    image: "/lovable-uploads/optimized/legal-agreements-800w.webp"
  },
  {
    id: "case3",
    title: "Compliance Monitoring System",
    client: "Small-Sized Law Firm",
    challenge: "Manually tracking regulatory changes across multiple jurisdictions created inefficiencies, compliance gaps, and increased risk exposure.",
    solution: "Implemented a cloud-based compliance monitoring platform that automated regulation tracking, policy updates, task assignments, and real-time reporting for firm-wide visibility.",
    results: [
      "Reduced incidents by 70%",
      "Streamlined policy updates across departments",
      "Improved audit readiness with real-time reporting",
      "Enhanced staff accountability through automated task assignments"
    ],
    source: {
      text: "VComply – Compliance Software for Law Firms",
      url: "https://www.v-comply.com/blog/compliance-software-for-law-firms-solutions/"
    },
    image: "/lovable-uploads/optimized/advisory-service-800w.webp"
  }
];
